<template>
  <table class="table table-bordered table-striped table-condensed">
    <thead>
      <tr>
        <th>ID</th>
        <th>Creation Date</th>
        <th>API</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="session in sessions">
        <td>{{session.id}}</td>
        <td>{{session.created_at | moment("LLL")}}</td>
        <td>
          <router-link :to="{name: 'CurlCatalog', query: { session: session.id }}"><button class="btn btn-secondary">Catalog</button></router-link>
          <router-link :to="{name: 'CurlPurchases', query: { session: session.id }}"><button class="btn btn-secondary">Purchases</button></router-link>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>

import devices from 'services/devices'

export default {
  name: 'device-sessions',
  props: ['deviceID'],
  data () {
    return {
      sessions: []
    }
  },
  created () {
    devices.sessions(this, this.deviceID)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/devices/DeviceSessions.vue